import type { Meta, StoryObj } from '@storybook/angular';
import { expect, within } from 'storybook/test';
import { ProductCustomBadgeComponent } from '../../app/content/layout/components/product/product-custom-badge/product-custom-badge.component';
import { withCommonDecorators } from '../_utils/story-helpers';
import { createDamilanoBarberaProduct } from '../_mocks';
import { ProductPriceService } from '../../app/core/services/product-price.service';
import { signal } from '@angular/core';

function withDiscountPercentage(pct: number) {
  return {
    provide: ProductPriceService,
    useValue: {
      currencyCode: signal('DKK'),
      getUnitName: () => 'fl.',
      calculateDiscountPercentage: () => pct,
      formatPriceLines: () => [],
    },
  };
}

const meta: Meta<ProductCustomBadgeComponent> = {
  title: 'Atoms/Product Custom Badge',
  component: ProductCustomBadgeComponent,
  parameters: {
    layout: 'centered',
    docs: {
      description: {
        component: 'Custom HTML badge overlay on product images. Supports {{pct}} placeholder for dynamic discount percentage.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<ProductCustomBadgeComponent>;

export const DiscountBadge: Story = {
  decorators: [...withCommonDecorators([withDiscountPercentage(25)])],
  args: {
    product: createDamilanoBarberaProduct({
      customBadgeHTML: '<div style="background: red; color: white; padding: 4px 8px; border-radius: 4px; font-weight: bold;">-{{pct}}%</div>',
    }) as any,
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/-25%/)).toBeInTheDocument();
  },
};

export const NoBadge: Story = {
  decorators: [...withCommonDecorators([withDiscountPercentage(0)])],
  args: {
    product: createDamilanoBarberaProduct({ customBadgeHTML: null }) as any,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-custom-badge')).toBeTruthy();
  },
};

export const ZeroDiscount: Story = {
  decorators: [...withCommonDecorators([withDiscountPercentage(0)])],
  args: {
    product: createDamilanoBarberaProduct({
      customBadgeHTML: '<div style="background: red; color: white; padding: 4px 8px;">-{{pct}}%</div>',
    }) as any,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-custom-badge')).toBeTruthy();
  },
};
